/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext } from 'react';

import { ContentContext } from 'context/ContentContext';

import { HeroSection } from 'ui/molecules/HeroSection/HeroSection';
import { RegistryWall } from 'ui/atoms/RegistryWall/RegistryWall';
import { Button } from 'ui/atoms/Button/Button';
import { PillarCards } from 'ui/organisms/PillarCards/PillarCards';

import styles from './AboutUsPage.module.scss';

import { BAND_ITEMS, HERO_BACKGROUND } from './AboutUsPage.data';
import { AboutSections } from './sections/AboutSections';

const AboutUsPage = () => {
  const { secondaryNavigation } = useContext(ContentContext);

  return (
    <div className={styles['about-us-page']}>
      <HeroSection
        align="left"
        background={HERO_BACKGROUND}
        className={styles.hero}
        title="The trusted company data foundation for enterprise AI."
        description="For over ten years we have sourced and connected official registry records from across the world. That foundation now powers ownership graphs, registry-grounded AI models and intelligent agents — with evidence behind every answer."
        actions={
          <Button type="blue" size="xl" route={secondaryNavigation.book_demo.slug}>
            Talk to our team
          </Button>
        }
        media={<RegistryWall />}
        mediaPosition="right"
      />

      <PillarCards theme="dark" columns={4} items={BAND_ITEMS} />

      <AboutSections />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default AboutUsPage;
